<template>
  <div class="container d-flex justify-content-center align-items-center mt-4">
    <div class="logo-container">
      <img
        class="img-fluid img-size-control"
        src="@/assets/ft-logo-login.png"
        width="300"
        alt="Falcon - Soluções Inteligentes"
      />
    </div>
    <div class="login">
      <form @submit.prevent="login">
        <div class="row mb-3">
          <h1 class="h1-bem-vindo poppins-light">
            FALCON
            <span class="poppins-semibold">RANK</span>
          </h1>
          <h2 class="h2-slogan poppins-light">
            Alcance a eficiência contábil e fiscal que seu município merece
          </h2>
        </div>
        <div class="row">
          <div class="form-group">
            <label for="email" class="label-login">Email</label>
            <input
              type="email"
              class="form-control"
              id="email"
              name="email"
              v-model="data.email"
              required
            />
          </div>
        </div>
        <div class="row">
          <div class="form-group">
            <label for="password" class="label-login">Senha</label>
            <input
              type="password"
              class="form-control"
              id="password"
              v-model="data.password"
              required
            />
          </div>
        </div>
        <div class="row">
          <div class="extand-login-button">
            <div class="d-flex flex-column align-items-start">
              <router-link to="/solicitar-acesso" class="link-acesso">Solicitar acesso</router-link>
              <router-link to="/esqueci-senha" class="link-acesso">Esqueci minha senha</router-link>
            </div>
            <button type="submit" class="btn btn-secondary">
              Entrar
            </button>
          </div>
        </div>
      </form>
      <div v-if="loginSucceeded" class="row mt-3">
      <!-- <div class="row mt-3"> -->
        <div class="col-md-12">
          <div
            class="alert alert-success alert-dismissible fade show"
            role="alert"
          >
            Logado com sucesso, redirecionando...
          </div>
        </div>
      </div>
      <div v-if="loginError" class="row mt-3">
        <div class="col-md-12">
          <div
            class="alert alert-danger alert-dismissible fade show"
            role="alert"
          >
            {{ loginError }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <Footer />
</template>

<script>
import axiosApi from "@/axios";
import { reactive } from "vue";
import { mapMutations } from "vuex";
import Footer from "@/components/Footer.vue";

export default {
  name: "Login",
  components: {
    Footer
  },
  setup() {
    const data = reactive({
      email: "",
      password: "",
    });

    return {
      data,
    };
  },
  data() {
    return {
      loginSucceeded: false,
      loginError: "",
    };
  },
  async created() {
    try {
      const response = await axiosApi.get("/api/validate-token", { withCredentials: true });
      if (response.data.success) {
        this.$router.push("/");
      }
    } catch (error) {
      // If validation fails, user should stay on login page
      // This includes cases where user was deleted
      console.log("Token validation failed, staying on login page");
      
      // Clear any remaining authentication data to prevent loops
      this.$store.commit('clearAuthData');
      
      // If it's a deleted user error, don't show generic error
      if (error.message !== "USER_DELETED") {
        console.error("Authentication error:", error);
      }
    }
  },
  methods: {
    ...mapMutations(['clearAuthData']),
    async login() {
      this.loginError = "";
      try {
        const response = await axiosApi.post(
          "/api/login",
          {
            email: this.data.email,
            password: this.data.password,
          },
          { withCredentials: true }
        );
        console.log("Login successful:", response.data);
        this.loginSucceeded = true;
        const forceChange = response.data.data?.force_password_change;
        setTimeout(() => {
          this.$router.push(forceChange ? "/trocar-senha" : "/");
        }, 2000);
      } catch (error) {
        this.loginError = error.response
          ? error.response.data.message
          : error.message;
        console.error(
          "Error logging in:",
          error.response ? error.response.data : error.message
        );
      }
    },
  },
};
</script>

<style>
.container {
  max-width: 800px;
  margin: 0 auto;
  padding-top: 20px;
  display: flex;
  justify-content: center;
  align-items: flex-start !important;

}

.logo-container {
  flex: 1;
  display: flex;
  justify-content: center;
  /* padding-right: 20px; */
  /* margin-top: 60px; */
}

.logo-container img {
  max-width: 100%;
  height: auto;
}

.login {
  flex: 1;
  /* background: #fff; */
  padding: 20px;
  /* border-radius: 8px; */
  /* box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); */
}

.login h1 {
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
}

.form-group input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
}

.extand-login-button {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.extand-login-button .btn {
  min-width: 100px;
  /* background-color: var(--azul-escuro); */
}

.logo-container .img-size-control {
  /* max-width: 250px; */
  height: auto;
}

.h1-bem-vindo {
  font-size: 1.9rem;
  color: #002f58;
}

.h2-slogan {
  font-size: 1.1rem;
  color: #004d91;
}

.login h1 {
  margin: 0;
}

.form-group .label-login {
  position: absolute;
  margin-top: -12px;
  background-color: white;
  color: #009dff;
  margin-left: 10px;
  padding: 0px 8px;
  font-size: 0.9rem;
}

.form-group input {
  min-height: 50px;
  margin-bottom: 15px;
}

.extand-login-button a:hover {
  text-decoration: underline;
}

.link-acesso {
  color: #009dff;
  text-decoration: none;
  font-size: 0.9rem;
}

.link-acesso:hover {
  text-decoration: underline;
}
</style>
